import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import EnrollmentCount from 'pages/Scheduling/EnrollmentCount'
import TeacherCell from 'pages/Scheduling/TeacherCell'

export default function SchedulingCourseSessionInfo({ selectedCourseSession }) {
  const { t } = useTranslation()
  const academicYearMarkingPeriods = useSelector(state => state.session?.academicYear?.markingPeriods)

  const getTerm = mp => {
    if (academicYearMarkingPeriods?.length === 1 && mp?.length === 1) {
      return 'Summer'
    } else if (mp?.length === academicYearMarkingPeriods?.length) {
      return 'Full Year'
    } else {
      return mp?.map(item => item.name).toString()
    }
  }

  return (
    <Stack
      flexDirection={'row'}
      justifyContent={'flex-start'}
      alignItems={'flex-start'}
      sx={{ backgroundColor: 'rgba(255, 146, 21, 0.04)', mt: 2, border: '1px solid rgba(255, 146, 21, 0.4)', borderRadius: 1 }}
    >
      <Box sx={{ borderRight: '1px solid rgba(255, 146, 21, 1)', m: 1, pl: 1, pr: 3 }}>
        <Typography variant="body2">{t('Course Name')}</Typography>
        <Typography variant="body2">{selectedCourseSession?.name}&nbsp;</Typography>
      </Box>
      <Box sx={{ borderRight: '1px solid rgba(255, 146, 21, 1)', m: 1, pl: 1, pr: 3 }}>
        <Typography variant="body2">{t('Teacher(s)')}</Typography>
        <TeacherCell enrollments={selectedCourseSession?.courseSessionEnrollments} />
      </Box>
      <Box sx={{ borderRight: '1px solid rgba(255, 146, 21, 1)', m: 1, pl: 1, pr: 3 }}>
        <Typography variant="body2">{t('Term')}</Typography>
        <Typography variant="body2">{getTerm(selectedCourseSession?.markingPeriods)}&nbsp;</Typography>
      </Box>
      <Box sx={{ borderRight: '1px solid rgba(255, 146, 21, 1)', m: 1, pl: 1, pr: 3 }}>
        <Typography variant="body2">{t('Room')}</Typography>
        <Typography variant="body2">&nbsp;</Typography>
      </Box>
      <Box sx={{ borderRight: '1px solid rgba(255, 146, 21, 1)', m: 1, pl: 1, pr: 3 }}>
        <Typography variant="body2">{t('Enrollment')}</Typography>
        <EnrollmentCount
          enrolled={selectedCourseSession?.enrollmentCount}
          quota={selectedCourseSession?.quota}
        />
      </Box>
    </Stack>
  )
}
